import React from "react";
import "./HomeContent.css";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import LearningPedagogy from "../function-components/Pedagogy";
import LearningResources from "../function-components/LearningResources";
function HomeContent() {
  return (
    <>
      <div className="banner-container">
        <img src="images/Banner1.png" alt="banner" className="banner-img" />
        <MenuNavbar />
      </div>
      <Floaticons />
      {/* section 1 */}
      <div className="leader-container">
        <div className="leader-wrap">
          <h2>Leader says</h2>
          <div className="leader-row">
            <div className="leader-box">
              <img
                src="images/Home/OpenQuote.png"
                alt="open-quote"
                className="open-quote"
              />
              <p className="leader-content">
                In today’s dynamic digital world, learning is the only
                competitive differentiator that helps us stay relevant in the
                ever-progressing security landscape. The learning and knowledge
                management team offers a multi-dimensional Security Learning HUB
                to help build new-age security skills and create a first-rate
                experience for our clients. Our aim is to provide holistic
                learning encompassing learnings on delivery, industry,
                professional and technical skills. Grade up your knowledge
                quotient to build a Secured tomorrow!​
              </p>
              <img
                src="images/Home/Closedquote.png"
                alt="closed-quote"
                className="closed-quote"
              />
            </div>

            <div className="leader-details">
              <img src="images/Home/ambrish.png" alt="leader-img" />
              <div className="leadership_text">
                <h3>Ambrish Rastogi</h3>
                <p>Lead - Learning and Leadership Development, ATC-GN</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="shell-container">
                <div className="shell-wrap-home">
                    <div className="shell-row row1">
                        <div className="shell-box">
                            <h2> Leadership Message </h2>
                            <div className='content'>
                                <p className='introContent'>In today's dynamic digital world, learning is the only competitive differentiator that helps us stay relevant in the ever-progressing security landscape. The learning and knowledge management team offers a multidimensional Security Learning HUB to help build new age security skills and create that WOW experience for our clients. The learning coliseum serves a wholistic learning encompassing learning on delivery, industry, professional and technical skills. Grade up your knowledge quotient to build a Secured tomorrow! <br />
                                    <br />
                                </p>
                                <div className='ld_img_sec'>
                                    <div><img src="images/OurTeam/Anupama _img.png" alt="ld_img" className='leadership_img' /></div>
                                    <div className='leadership_text'><h3>Anupama Nithyanand</h3>
                                        <p>Lead - Learning & Talent Transformation <br /> and Sustainability Research Cell</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="shell-row row2">
                        <div className="shell-box">
                            <img src="images/video.png" alt="video" className='video-img' />
                        </div>
                    </div>
                </div>
            </div> */}

      {/* section 2  */}
      <div className="pedagogy-container">
        <LearningPedagogy />
      </div>

      {/* section 3 */}
      <div className="learning-assests-container">
        <div className="learning-assets-wrap">
          <LearningResources />
          {/* <div className="learning-assets-row">
                        <div className="learning-assets-box">
                            <img src="images/Home/Percipio.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://accenture.percipio.com/'>
                                Percipio
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/Pluralsight.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://app.pluralsight.com/library/'>
                                Pluralsight
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/Cyberbit.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://login.www.cyberbitrange.com/login?state=hKFo2SBTVXFRRkFFUVFfU1hWZkhEUDByTjNEeUtkVkFKMGxISqFupWxvZ2luo3RpZNkgbHJvT0xsYkhISWs1d00tU1hhRmNNellpTkhfVjE3WlWjY2lk2SBMU1VUZExwVldLWnkzVHY0NU1hRkxsblJNa3dqRVg0eA&client=LSUTdLpVWKZy3Tv45MaFLlnRMkwjEX4x&protocol=oauth2&redirect_uri=https%3A%2F%2Fwww.cyberbitrange.com%2Fauth%2Fcallback&scope=openid%20profile%20email%20oauth-authorization%20app_metadata%20user_metadata&audience=https%3A%2F%2Frange-prod.auth0.com%2Fapi%2Fv2%2F&internalError=null&response_type=code&response_mode=query&nonce=dWhRdkdsVFpZa0xsYzJsbnY0WHRRc1R0NHViZnF0VVQ1TXZnT3Q1eUdmSg%3D%3D&code_challenge=6umTecB5Bv0kU_4LbGceP-G2B1qUmllwvzJK0-dMM5Y&code_challenge_method=S256&auth0Client=eyJuYW1lIjoiYXV0aDAtc3BhLWpzIiwidmVyc2lvbiI6IjEuMjIuMiJ9'>
                                Cyberbit
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/DKP.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://deepknowledge.accenture.com/login/index.php'>
                                Deep Knowledge Portal
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/myLearning.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://mylearning.accenture.com/mylearningui/learner/home'>
                                myLearning
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/LearningBoards.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://mylearning.accenture.com/mylearningui/learner/home'>
                                Learning Boards
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/LKMPortal.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://atci.lkm.accenture.com'>
                                LKM Portal
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/LKMCalendar.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='https://atci.lkm.accenture.com/learning-calendar/'>
                                LKM Calendar
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                        <div className="learning-assets-box">
                            <img src="images/Home/TQ.png" alt="learning-asset-img" className='learning-img' />
                            <a className="learning-assets-content" href='#'>
                                TQ
                                <img src="images/Home/LinkIcon.png" alt="link-icon" className='link-icon' />
                            </a>
                        </div>
                    </div> */}
        </div>
      </div>

      {/* section 4 */}
      <div className="team">
        <h2 className="sectionHeading">Our Team </h2>
        <div className="teamWrapper">
          <div className="innerContainer">
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Gajendra-Mallik.png" />
              </div>
              <div className="contentWrap">
                <h3>Gajendra Mallik</h3>
                <p>Lead (Delivery, Security & IE)</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/CPCL-Sreenivasa-Rao.png" />
              </div>
              <div className="contentWrap">
                <h3>CPCL Sreenivasa Rao</h3>
                <p>Lead</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Soma-Tiwari.png" />
              </div>
              <div className="contentWrap">
                <h3>Soma Tiwari</h3>
                <p>Lead</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Sunil.png" />
              </div>
              <div className="contentWrap">
                <h3>Sunil Singh</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Satyajeet-Mishra.png" />
              </div>
              <div className="contentWrap">
                <h3>Satyajeet Mishra</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            {/* <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Kumanan.png" />
              </div>
              <div className="contentWrap">
                <h3>Kumanan Kadhirvelu</h3>
                <p>Technical Trainer</p>
              </div>
            </div> */}
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Rohit.png" />
              </div>
              <div className="contentWrap">
                <h3>Raja Rohit</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Sanoj.png" />
              </div>
              <div className="contentWrap">
                <h3>Sanoj Chakkithara Subramanian</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Sreeja-Swaminathan.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Sreeja Swaminathan</h3>
                                <p>Training Delivery</p>
                            </div>
                        </div> */}
            {/* <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/AbhishekPandey.png" />
              </div>
              <div className="contentWrap">
                <h3>Abhishek Pandey</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Aditya.png" />
              </div>
              <div className="contentWrap">
                <h3>Aditya Shrungi</h3>
                <p>Technical Trainer</p>
              </div>
            </div> */}
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Twinkle.png" />
              </div>
              <div className="contentWrap">
                <h3>Twinkle Batra</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Zeeshan.png" />
              </div>
              <div className="contentWrap">
                <h3>M. Zeeshan Aamiri</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Roshna.png" />
              </div>
              <div className="contentWrap">
                <h3>Roshna Khalid</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/ArghadipProfile.png" />
              </div>
              <div className="contentWrap">
                <h3>Arghadip Banerjee</h3>
                <p>Technical Trainer</p>
              </div>
            </div>

            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Vinita_172x172.png" className="updated_img"/>
              </div>
              <div className="contentWrap">
                <h3>Vinita Gupta</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Karthick_172x172.png" className="updated_img"/>
              </div>
              <div className="contentWrap">
                <h3>Karthick D. Arumugam</h3>
                <p>Technical Trainer</p>
              </div>
            </div>
            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Pravallika_172x172.png" className="updated_img"/>
              </div>
              <div className="contentWrap">
                <h3>Pravallika Kalanadhabhatta</h3>
                <p>Technical Trainer</p>
              </div>
            </div>

            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/Utkarsh_172x172.png" className="updated_img"/>
              </div>
              <div className="contentWrap">
                <h3>Utkarsh Prajapati</h3>
                <p>Technical Trainer</p>
              </div>
            </div>

            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/DhruvPruthi_trainer.png" />
              </div>
              <div className="contentWrap">
                <h3>Dhruv Pruthi</h3>
                <p>Technical Trainer</p>
              </div>
            </div>

            <div className="cardWrap">
              <div className="imageWrap">
                <img src="images/OurTeam/p.alathur.rangaswamy_172x172_round.png" />
              </div>
              <div className="contentWrap">
                <h3>Prathiksha Alathur Rangaswamy</h3>
                <p>Technical Trainer</p>
              </div>
            </div>

            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Md-Rizwan-Hasan.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Md Rizwan Hasan</h3>
                                <p>Technical Trainer</p>
                            </div>
                        </div> */}
            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Joshua-Daniel-Marri.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Joshua Daniel Marri</h3>
                                <p>Technical Trainer</p>
                            </div>
                        </div> */}

            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Sarada-Kolluri.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Sarada Kolluri</h3>
                                <p>Training Operations</p>
                            </div>
                        </div> */}
            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Ranjeeta-Mukherjee.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Ranjeeta Mukherjee</h3>
                                <p>Training Operations</p>
                            </div>
                        </div> */}
            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Yazhini-Devi.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Yazhini Devi</h3>
                                <p>Training Operations</p>
                            </div>
                        </div> */}
            {/* <div className="cardWrap">
                            <div className='imageWrap'>
                                <img src='images/OurTeam/Savitri-Bhati.png' />
                            </div>
                            <div className='contentWrap'>
                                <h3>Savitri Bhati</h3>
                                <p>Training Delivery</p>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
export default HomeContent;
